import ButtonField from '@/components/form-control/ButtonField'
import { DATA_TABLE_PLANT } from '@/constant/common'
import { Stack, Typography } from '@mui/material'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'
import PlantTable from './PlantTable'

type Props = {}

const PumpData = (props: Props) => {

  const handleClick = () => {

  }

  return (
    <SetUpLayout
      title='Plant'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMapSmall />}
      footer={<Stack p="25px 32px"><FooterSetup /></Stack>}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "20px", lineHeight: "2.4" }}>Review Plant Data</Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      <PlantTable rows={DATA_TABLE_PLANT} />
    </SetUpLayout>
  )
}

export default PumpData